import React from 'react';
import {withStyles} from "@material-ui/core";
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ParticipationGrid from "../../components/Participations/ParticipationGrid";
import Toolbar from "../../components/Toolbar/Toolbar";

const ParticipationsIndex = ({classes, participations, course}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={ i18n.get('participations.heading_participation', {course: course.name})}
            subtitle={`${participations.length} ${i18n.get('participations.number_of_participations')}`}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('participations.new_participant'),
                    href: `/participations/${course.id}-${course.name_short}/create`,
                }
            ]}
        />

        <ParticipationGrid participations={participations}/>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(ParticipationsIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/participations/Index.jsx